import React from 'react';

const WidgetCompany = (props) => {
  const _goHome = () => {
    props.actionProvider._home(-1);
  };

  const _goCompany = () => {
    window.open('https://company.aniplustv.com', '', '');
  };
  return (
    <>
      <div className="company-info-wrapper">
        <div className="company-header">
          <h1>글로벌 콘텐츠 & 미디어 기업 애니플러스</h1>
          <div className="company-description">
            애니플러스는 코스닥 상장사로서 일본 애니메이션을 핵심 콘텐츠로 하는
            국내외 방송사업을 기반으로 VOD 유통, 극장배급, MD, 전시이벤트 등
            다양한 관련 사업을 전개하고 있습니다. 또한, 동남아시아에서 K-콘텐츠
            전문 채널, K-PLUS를 송출하고 있으며, 드라마 제작 및 투자,
            해외배급사업을 통해 글로벌 종합 콘텐츠 & 미디어 기업으로 성장하고
            있습니다.
          </div>
        </div>
        <div className="company-details">
          <div className="detail-item">
            <div className="detail-title">본점 소재지</div>
            <div className="detail-content">
              서울시 영등포구 국제금융로 10 THREE IFC 28층
            </div>
          </div>
          <div className="detail-item">
            <div className="detail-title">대표이사</div>
            <div className="detail-content">전승택</div>
          </div>
          <div className="detail-item">
            <div className="detail-title">주요사업</div>
            <div className="detail-content">
              <ul>
                <li>방송사업 : 국내외 방송채널 송출 (애니메이션, 드라마)</li>
                <li>
                  콘텐츠사업 : 온라인 서비스, VOD 유통, 상영회 및 극장배급
                </li>
                <li>MD 사업 : 상품화, 상설매장 및 콜라보카페</li>
                <li>이벤트사업 : Anime X Game Festival</li>
                <li>전시사업 : 미디어아트 및 콜라보전시, 상설전시장</li>
                <li>드라마사업 : 드라마 제작 및 투자, 해외배급</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="prev-chat-container" style={{ paddingTop: 10 }}>
        <div className="prev-contaner">
          <div onClick={_goCompany} className="prev">
            <img src="/img/chatbot/icon_company.png" />
            회사 홈페이지 바로가기
          </div>

          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default WidgetCompany;
